import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Field, FieldLabel, Switch } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function WochendurchschnittFields() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <div className="flex flex-col gap-5">
      <div className="grid md:grid-cols-2">
        <form.AppField name="abwesenheiten.allgemein.dynamisch_wochenschnitt_start">
          {(field) => (
            <div className="col-span-2 grid md:grid-cols-2 items-start gap-4">
              <field.HoursInput
                label={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.wochendurchschnitt.start_abwesenheitszeit.label',
                )}
                placeholder="hh:mm"
                maxHours={24}
                suffix={t(
                  'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.wochendurchschnitt.start_abwesenheitszeit.suffix',
                )}
                isRequired
              />
            </div>
          )}
        </form.AppField>
      </div>
      <form.AppField name="abwesenheiten.allgemein.dynamisch_wochenschnitt_limitieren">
        {(field) => (
          <Field orientation="horizontal" className="flex gap-2">
            <Switch
              id={field.name}
              checked={field.state.value}
              onCheckedChange={field.handleChange}
              onBlur={field.handleBlur}
            />

            <FieldLabel
              htmlFor={field.name}
              className="text-neutrals-900 text-sm font-normal leading-5 max-w-fit">
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.wochendurchschnitt.abwesenheitszeit_limitieren.label',
              )}
            </FieldLabel>
          </Field>
        )}
      </form.AppField>
    </div>
  );
}
